import { useMediaQuery } from '@chakra-ui/react';
import { MOBILE_VIEWPORT_QUERY } from '../../utils/bowerClient';

/**
 * True below Chakra's `md` breakpoint (48em) — the point at which panels swap
 * from a desktop popover to a mobile bottom sheet.
 *
 * One query, read synchronously on the first render (`ssr: false`), so mobile
 * never flashes the desktop presentation. `useBreakpointValue` subscribed to
 * all six theme breakpoints and re-rendered every caller (item pages among
 * them) at each one a window resize crossed. Kept as its own tiny hook so panel
 * code doesn't pull in `useMobileDetection`'s camera/mic device enumeration.
 */
export function useIsMobileViewport(): boolean {
  // The query lives in utils/bowerClient.ts so this hook and the imperative
  // helper the request interceptor uses cannot drift apart.
  const [isMobile] = useMediaQuery(MOBILE_VIEWPORT_QUERY, { ssr: false });
  return isMobile;
}
